<template>
	<div class="border-bottom py-1" @click="$emit('click', $event)">
		{{customer.name}}<br>
		<span class="small">{{customer.address}}, {{customer.postal}} {{customer.city}}</span>
	</div>
</template>

<script>
	export default {
		name: "CustomerListItem",
		props: {
			customer: Object
		}
	}
</script>

<style scoped>

</style>
